




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ISortParameters, ITransaction } from "@/interfaces";
import TransactionService from "@/services/transaction";
import { paginationLimit } from "@/constants";
import transaction from '@/services/transaction';

@Component
export default class LatestTransactions extends Vue {
  @Prop({ required: true }) public transactionType: number;
  @Prop({ required: true }) public transactionGroup: number;

  private paginationLimit: number = paginationLimit;
  private transactions: ITransaction[] | null = null;

  get sortParams() {
    return this.$store.getters["ui/transactionSortParams"];
  }

  set sortParams(params: ISortParameters) {
    this.$store.dispatch("ui/setTransactionSortParams", {
      field: params.field,
      type: params.type,
    });
  }

  @Watch("transactionType")
  public async onTransactionTypeChanged(): Promise<void> {
    this.transactions = null;
    await this.getTransactions();
  }

  public async mounted(): Promise<void> {
    await this.prepareComponent();
  }

  private async prepareComponent() {
    await this.getTransactions();

    this.$store.watch(
      (state) => state.network.height,
      (value) => this.getTransactions(),
    );
  }

  private async getTransactions() {
    let type = this.transactionType.toString()
    let data = await TransactionService.latestTransactions();
    if(type && type.length>3)
    data = data.filter(t=> t.operations[0][0] === type)
    this.transactions = data.map((transaction: ITransaction) => ({ ...transaction ,block_num:transaction['block_num'] }));
  }

  private onSortChange(params: ISortParameters) {
    this.sortParams = params;
  }
}
